import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Pipe({
  name: 'columnName',
  standalone: true,
})
export class ColumnNamePipe implements PipeTransform {
  private columnMappings: { [key: string]: string } = {
    year: 'year',
    month: 'month',
    totalImageCount: 'totalAnalysisImageCount',
    totalAnalysisCount: 'totalAnalysisReportCount',
    customerBranchName: 'customerBranch',
  };

  constructor(private translate: TranslateService) {}

  transform(value: string): Observable<string> {
    const translationKey = this.columnMappings[value] || value;
    return this.translate.get(translationKey);
  }
}
